var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function Svg3OaksSvg(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "800px",
    height: "800px",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    className: "si-glyph si-glyph-three-ball",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "647") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#434343"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.518,7.071 C2.046,7.071 0.04,9.066 0.04,11.529 C0.04,13.99 2.046,15.985 4.518,15.985 C6.99,15.985 8.994,13.99 8.994,11.529 C8.993,9.066 6.989,7.071 4.518,7.071 L4.518,7.071 Z M5.082,8.454 C3.076,8.454 1.449,10.086 1.449,12.096 C1.449,12.918 0.732,12.566 0.732,11.377 C0.732,9.365 2.359,7.736 4.367,7.736 C5.553,7.736 5.902,8.454 5.082,8.454 L5.082,8.454 Z",
    className: "si-glyph-fill"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.518,7.071 C10.48,7.071 9.536,7.437 8.776,8.028 C8.907,8.185 9.026,8.35 9.137,8.521 C9.754,8.037 10.522,7.736 11.367,7.736 C12.553,7.736 12.902,8.454 12.082,8.454 C11.129,8.454 10.27,8.83 9.621,9.432 C9.889,10.078 10.039,10.786 10.039,11.53 C10.039,12.859 9.564,14.078 8.775,15.029 C9.535,15.62 10.479,15.986 11.517,15.986 C13.989,15.986 15.993,13.991 15.993,11.53 C15.993,9.066 13.989,7.071 11.518,7.071 L11.518,7.071 Z",
    className: "si-glyph-fill"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.018,7.197 C8.976,6.428 10.192,5.967 11.518,5.967 C11.922,5.967 12.315,6.012 12.696,6.093 C12.88,5.605 12.994,5.082 12.994,4.53 C12.994,2.067 10.99,0.072 8.518,0.072 C6.046,0.072 4.04,2.067 4.04,4.53 C4.04,5.04 4.144,5.522 4.303,5.978 C4.375,5.975 4.446,5.967 4.518,5.967 C5.844,5.967 7.06,6.429 8.018,7.197 L8.018,7.197 Z M8.367,0.736 C9.553,0.736 9.902,1.454 9.082,1.454 C7.076,1.454 5.449,3.086 5.449,5.096 C5.449,5.918 4.732,5.566 4.732,4.377 C4.732,2.365 6.359,0.736 8.367,0.736 L8.367,0.736 Z",
    className: "si-glyph-fill"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg3OaksSvg);
export default __webpack_public_path__ + "static/media/3oaks-svg.34ab8ef634da4f5102f2fadb98e4de12.svg";
export { ForwardRef as ReactComponent };